module.exports = __webpack_public_path__ + "static/media/56.7faf23ee.jpg";